<script>
import Notification from '../../reUse/Notification.vue';
export default {
  components: {
    Notification,
  },
  data() {
    return {
      text: '',
      types: '',
      ShowNoti: false,
      zig: '',
      isSubmitting: false,
    }
  },
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      axios.get('./api/nastavitve/splosno/zig/', {withCredentials: true}).then((response) => {
        this.zig = response.data.zig;
      }).catch((napaka) => {
        this.text = napaka.response.data.napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    PosodobiZig() {
      this.isSubmitting = true;
      var podatki = new FormData();
      if ($(this.$refs.datoteka)[0].files[0] !== undefined) {
        podatki.append('zigLetalisca', $(this.$refs.datoteka)[0].files[0]);
      }
      podatki.append('icao', 5);
      axios.post('./api/nastavitve/splosno/zig/', podatki, {withCredentials: true}).then((response) => {
        if (response.data.datoteka !== null) {
          this.zig = response.data.datoteka;
        }
        $(this.$refs.datoteka).val('');
        this.isSubmitting = false;
      }).catch((napaka) => {
        this.isSubmitting = false;
      });
    },
  }
}
</script>
<template>
  <!-- VNOS PODATKOV ZA IZPIS -->
  <div class="form-section">
    <div class="section-header">
      <div class="section-icon">
        <i class="fas fa-file-alt"></i>
      </div>
      <div class="section-title">
        <h3>Žig letališča</h3>
        <p>Slika žiga letališča, ki bo uporabljena na izpisih</p>
      </div>
    </div>
    <div class="section-content">
      <!-- LOGO -->
      <div class='form-grid'>
        <div class="form-group" v-show="zig !== ''">
          <p class="label-time p-2">Trenutna slika žiga za dokumente</p>
          <img :src="'./img/upload/' + zig" width="200px"/>
        </div>
        <div class="form-group">
          <label class="label-time p-2" for="potnik-ime-{{index}}"> {{ zig !== '' ? 'Izberite novo sliko žiga za izpise' : 'Izberite sliko žiga, ki bo prikazana na izpisih'}}</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="file" id="{{index}}" ref="datoteka" />
        </div>
      </div>
    </div>
    <!-- Form Actions -->
    <div class="form-actions">
      <div class="action-buttons">
        <button type="button"
                class="btn btn-primary"
                @click.prevent="PosodobiZig()"
                :disabled="isSubmitting">
          <i class="fas fa-sync-alt" v-if="!isSubmitting"></i>
          <i class="fas fa-sync-alt fa-spin" v-if="isSubmitting"></i>
          <span v-if="isSubmitting">Posodabljam</span>
          <span v-else>Posodobi vnos</span>
        </button>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="BrisiZapis()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
</template>